export default [
    {
        field: 'hr_employee_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Empleado',
            disabled:true,
        },
        //value: 30,
        options: {
            data: [],
            text: 'nameComplete',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'hr_contract_type_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Plazo Contrato',
            disabled:true,
        },
        //value: 30,
        options: {
            data: [],
            text: 'name',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'hr_contract_period_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Periodo Contrato',
            disabled:true,
        },
        //value: 30,
        options: {
            data: [],
            text: 'name',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'weekly_hours',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Horas semanales',
            disabled:true,
        },
        rules: ['required', 'numeric'],
    },
    {
        field: 'base_salary',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Monto Base',
            disabled:true,
        },
        format: 'currency',
        rules: ['required', 'numeric'],
    },
    {
        field: 'collation',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Monto Colación',
            disabled:true,
        },
        format: 'currency',
        rules: ['required', 'numeric'],
    },
    {
        field: 'mobilization',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Monto Movilización',
            disabled:true,
        },
        format: 'currency',
        rules: ['required', 'numeric'],
    },
    {
        field: 'init_date',
        type: 'datePicker',
        vuetifyProps: {
            label: 'Inicio Contrato',
            disabled:true,
        },
        rules: ['required'],
    },
    {
        field: 'end_date',
        type: 'datePicker',
        vuetifyProps: {
            label: 'Fin Contrato',
            disabled:true,
        },
    },
    {
        field: 'vacations_since',
        type: 'datePicker',
        vuetifyProps: {
            label: 'Inicio Vacaciones',
        },
        // rules: ['required'],
    },
    {
        field: 'vacations_progressive_days',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Días Progresivos',
        },
        rules: ['numeric', 'isNotNegative'],
    },
]
